


















import { FoundProducts } from '@/model/find-products-response';
import { ProductListFilter } from '@/model/product-list-filter';
import { ProductCollection } from '@/service/product';
import { Util } from '@/util/util';
import Vue from 'vue';
import ProductFilterJumbotron from '../product-filter/ProductFilterJumbotron.vue';

interface VM {
  calculatedProducts: FoundProducts | null;
}

export default Vue.extend({
  name: 'ProductSearchWrapper',
  components: {
    'product-filter-jumbotron': ProductFilterJumbotron
  },
  props: {
    backgroundImageLink: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    targetUrl: {
      type: String,
      default: ''
    },
    activeFilter: {
      type: Object as () => ProductListFilter,
      default: () => new ProductListFilter()
    },
    foundProducts: {
      type: Object as () => FoundProducts,
    },
    v2Styling: {
      type: Boolean,
      default: false
    },
    showFilters: {
      type: Boolean,
      default: false
    }
  },
  data(): VM {
    return {
      calculatedProducts: null
    };
  },
  computed: {
    products(): FoundProducts | {} {
      return this.calculatedProducts || this.foundProducts;
    },

  },
  methods: {
    onUpdate() {
        if ((this.$listeners as Record<string, Function>).updated) {
          this.$emit('updated');
          return;
        }

        window.location.href = this.activeFilter.clone().getUrl(this.targetUrl === '' ? Util.getConfig().searchPath : this.targetUrl);
    },
    refresh() {
      // quite an ugly hack for now should be refactored in the future
      if (this.$listeners && this.$listeners.updated) {
        return;
      }
      this.getFilterInformation();
    },

    getFilterInformation() {
      const searchParams = this.activeFilter.getFilter();

      ProductCollection.getInstance()
        .findProducts(searchParams)
        .then(foundProducts => {
          this.calculatedProducts = foundProducts;
        });
    }
  },
  mounted() {
    this.refresh();
  },
});
